const $config = {
	REQUEST_URL: "//io.xkw.com/iolog/track-log",
	//REQUEST_URL: "http://10.1.22.8:9091/track-log?data=",
	SEARCH_COOKIE_NAME:"$latest_inside_search_keyword",
	ZXXK_USER_INFO_KEYS:["xk.passport.info"],
	ZXXK_USER_IMAGE_KEY:"userimage",
	DOMAINS:["zxxk.com","xkw.cn","xkw.com"],
	KEYWORDS:[
		{
			SITE:"zxxk.com",
			QUERY_NAME: "kw",
			COOKIE_NAME:"zxxk_latest_search_keyword"
		},
		{
			SITE:"yx.xkw.com",
			QUERY_NAME: "kd",
			COOKIE_NAME:"yx_latest_search_keyword"
		},
		{
			SITE:"wxt.xkw.com",
			QUERY_NAME: "title",
			COOKIE_NAME: "wxt_latest_search_keyword"
		},
		{
			SITE:"zujuan.xkw.com",
			QUERY_NAME: "keyword",
			COOKIE_NAME: "zujuan_latest_search_keyword"
		}
	],
	SITES:{
		//主站
		MAIN:["www.zxxk.com"],
		//网校通
		WXT:["wxt.zxxk.com"],
		//学科子站
		SUBJECT:[
			//语文
			"yw.zxxk.com",
			//数学
			"sx.zxxk.com",
			//英语
			"yy.zxxk.com",
			//物理
			"wl.zxxk.com",
			//化学
			"hx.zxxk.com",
			//生物
			"sw.zxxk.com",
			//历史
			"ls.zxxk.com",
			//政治
			"zz.zxxk.com",
			//地理
			"dl.zxxk.com",
			//科学
			"kx.zxxk.com",
			//历史与社会
			"lsysh.zxxk.com",
			//信息
			"xx.zxxk.com",
			//音乐
			"yy.zxxk.com",
			//美术
			"ms.zxxk.com",
			//体育
			"ty.zxxk.com",
			//劳技
			"lj.zxxk.com",
			//拓展
			"tz.zxxk.com",
			//通用技术
			"tyjs.zxxk.com",
			"khfw.zxxk.com"
		],
		//类别
		CATEGORY:[
			//课件
			"kj.zxxk.com",
			//教案
			"ja.zxxk.com",
			//视频
			"sp.zxxk.com",
			//试卷
			"sj.zxxk.com",
			//学案
			"xa.zxxk.com",
			//素材
			"sc.zxxk.com",
			//研修
			"yx.xkw.com"
		],
		//中高考、初高中子站
		EXAMINATION:[
			//中考
			"zhongkao.zxxk.com",
			//高考
			"gaokao.zxxk.com",
			//初中
			"middle.school.zxxk.com",
			//高中
			"high.school.zxxk.com"
		],
		//用户中心
		USER_CENTER:["user.zxxk.com"],
		//搜吧
		SEARCH:["search.zxxk.com"],
		//名校
		MINGXIAO:["mingxiao.zxxk.com"],
		//书城
		BOOK:["b.zxxk.com"],
		//头条
		NEWS:["news.zxxk.com"],
		//精品
		JINGPIN:["jp.zxxk.com"],
		//M站
		Mobile:["m.zxxk.com"]
	}
};


//预置属性(浏览/点击事件均需获取的数据)
const $view = {
	//用户ID
	$user_id:"",
	//设备id
	$device_id:"",
	//触发时间
	$time:"",
	//操作系统
	$os:"",
	//操作系统版本
	$os_version:"",
	//设备制造商
	$manufacturer:"",
	//设备型号
	$model:"",
	//屏幕宽度
	$screen_width:"",
	//屏幕高度
	$screen_height:"",
	//浏览器名称
	$browser:"",
	//浏览器版本
	$browser_version:"",
	//浏览器语言
	$browser_language:"",
	//是否首次访问
	$is_first_time:"",
	//前向地址
	$referrer: "",
	//前向域名
	$referrer_host: "",
	//最近一次站外前向地址
	$latest_referrer:"",
	//最近一次站外前向域名
	$latest_referrer_host:"",
	//本次流量来源类型（包含自然）
	$latest_traffic_source_type:"",
	//SDK类型
	$lib:"full",
	//SDK版本
	$lib_version:"1.0",
	//页面标题
	$title:"",
	//页面地址
	$url:"",
	//页面地址域名
	$url_host:"",
	//页面路径
	$url_path:"",
	//产品
	$product:"",
	//应用
	$application:"",
	//应用版本
	$app_version:"",
	//平台
	$platform:"",
	//是否B端用户
	$is_tob:"",
	//B端产品权限
	$tob_rights:"",
	//C端产品权限
	$toc_rights:"",
	//所属学校ID
	$school_id:"",
	//学段
	$stage:"",
	//学科
	$subject:"",
	//教材版本
	$book_version:""
};

$view[$config.SEARCH_COOKIE_NAME] = "";

//元素点击
const $clickElement = {
	//元素样式名
	$element_class_name: "",
	//元素内容
	$element_content: "",
	//元素ID
	$element_id: "",
	//元素名字
	$element_name: "",
	//元素选择器
	$element_selector: "",
	//元素链接地址
	$element_target_url: "",
	//元素类型
	$element_type: "",
	//视区宽度
	$viewport_width: "",
	//视区高度
	$viewport_height:"",
	//元素位置
	$offsetx:"",
	$offsety:"",
};



export {$view,$clickElement,$config};
